exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".placeholder[data-v-5f2c5c3c] {\n  border: 3px dashed #8d8d8d;\n  color: #747474;\n  min-height: 300px;\n  cursor: pointer;\n  background-color: #dde4e7;\n  opacity: .5;\n  transition: opacity .15s;\n}\n.placeholder[data-v-5f2c5c3c]:hover {\n  opacity: 1;\n  transition: opacity .15s;\n}\n", ""]);

// exports
